<div class="container">

  <app-header-dialog [iconName]="'attach_money'">
    Anuidade Lotes - Preços
  </app-header-dialog>

  <div class='lot-form'>
    <form name="lotForm" [formGroup]='lotForm' autocomplete="off">

      <mat-form-field class="lot-width" appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="lotForm.controls.name"
          autocomplete="off">
        <mat-error *ngIf="lotForm.controls.name.hasError('required')">
          O Nome é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="date-width" appearance="outline">
        <mat-label>Data Limite</mat-label>
        <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
          [formControl]="lotForm.controls.until_date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="lotForm.controls.until_date.hasError('required')">
          A data limite é obrigatoria
        </mat-error>
      </mat-form-field>


      <button mat-raised-button (click)='insert()' [disabled]="lotForm.invalid" *ngIf="!_annuityLotService.isEdit">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

      <button mat-raised-button (click)='update()' [disabled]="lotForm.invalid" *ngIf="_annuityLotService.isEdit">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>


    </form>
  </div>



  <mat-tab-group>


    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>person</mat-icon>
        <div>Sócios</div>
      </ng-template>

      <div class='tab-content'>
        <div *ngIf="_annuityLotService.isEdit">

          <div class='lot-form'>
            <!-- TABLE -->
            <mat-table [dataSource]="_annuityCatPriceService.productCatPricePartnerTrueDataSource" matSort
              style='height:250px; overflow:auto; margin: 0;'>

              <!-- icon Column -->
              <ng-container matColumnDef="icon">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>attach_money</mat-icon>
                </mat-cell>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="category">
                <mat-header-cell *matHeaderCellDef> Categoria </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.name }} </mat-cell>
              </ng-container>


              <!-- Value Column -->
              <ng-container matColumnDef="value" style='text-align: right;'>
                <mat-header-cell *matHeaderCellDef> Valor </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.value | currency:'BRL':'':'1.2-2' }} </mat-cell>
              </ng-container>

              <!-- Value Column -->
              <ng-container matColumnDef="defaulting" style='text-align: right;'>
                <mat-header-cell *matHeaderCellDef> Valor PIX </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.value_pix | currency:'BRL':'':'1.2-2' }} </mat-cell>
              </ng-container>

              <!-- edit Column -->
              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='openCatPriceDialog(true, element)' style='background-color: whitesmoke;'>
                    <mat-icon class='icon-info' style='font-size:1.5em;'>
                      info_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>

              <!-- delete Column -->
              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='deletePrice(element)' style='background-color: whitesmoke;'>
                    <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>

              <!-- Header -->
              <mat-header-row *matHeaderRowDef="displayedLotPricesColumns"></mat-header-row>

              <!-- Row -->
              <mat-row *matRowDef="let row; columns: displayedLotPricesColumns;">
              </mat-row>

            </mat-table>
            <!-- END TABLE -->
          </div>

          <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
            <button mat-raised-button (click)='openCatPriceDialog(true, null)' *ngIf="_annuityLotService.isEdit">
              <mat-icon class='icon-add'>add_circle_outline</mat-icon>
            </button>
          </div>

        </div>



      </div>

    </mat-tab>


    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>person_outline</mat-icon>
        <div>Não Sócios</div>
      </ng-template>

      <div class='tab-content'>
        <div *ngIf="_annuityLotService.isEdit">

          <div class='lot-form'>
            <!-- TABLE -->
            <mat-table [dataSource]="_annuityCatPriceService.productCatPricePartnerFalseDataSource" matSort
              style='height:250px; overflow:auto; margin: 0;'>

              <!-- icon Column -->
              <ng-container matColumnDef="icon">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>attach_money</mat-icon>
                </mat-cell>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="category">
                <mat-header-cell *matHeaderCellDef> Categoria </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.name }} </mat-cell>
              </ng-container>

              <!-- Value Column -->
              <ng-container matColumnDef="value" style='text-align: right;'>
                <mat-header-cell *matHeaderCellDef> Adimplente </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.value | currency:'BRL':'':'1.2-2' }} </mat-cell>
              </ng-container>

              <!-- Value Column -->
              <ng-container matColumnDef="defaulting" style='text-align: right;'>
                <mat-header-cell *matHeaderCellDef> Inadimplente </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.value_defaulting | currency:'BRL':'':'1.2-2' }} </mat-cell>
              </ng-container>

              <!-- edit Column -->
              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='openCatPriceDialog(false, element)' style='background-color: whitesmoke;'>
                    <mat-icon class='icon-info' style='font-size:1.5em;'>
                      info_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>

              <!-- delete Column -->
              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='deletePrice(element)' style='background-color: whitesmoke;'>
                    <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>

              <!-- Header -->
              <mat-header-row *matHeaderRowDef="displayedLotPricesColumns"></mat-header-row>

              <!-- Row -->
              <mat-row *matRowDef="let row; columns: displayedLotPricesColumns;">
              </mat-row>

            </mat-table>
            <!-- END TABLE -->
          </div>

          <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
            <button mat-raised-button (click)='openCatPriceDialog(false, null)' *ngIf="_annuityLotService.isEdit">
              <mat-icon class='icon-add'>add_circle_outline</mat-icon>
            </button>
          </div>

        </div>



      </div>

    </mat-tab>

  </mat-tab-group>













</div>